/**
 * Swedish pluralization for "tillfälle" (occasion).
 * 1 → "1 tillfälle", 2+ → "2 tillfällen"
 */
export function pluralizeTillfalle(count: number): string {
  return `${count} ${count === 1 ? 'tillfälle' : 'tillfällen'}`;
}
